import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

/** Profile served by backoffice-be (GET /backoffice/v1/users/me), which asks auth-service for the session user. */
export interface CurrentUserProfile {
    aid: string;
    username: string;
    /** Functional roles joined with ", ", or null when the user has none: a display label. */
    roleName: string | null;
}

/** Every backoffice-be response is the fink envelope: the payload travels in `data`. */
interface BaseOutput<T> {
    data: T;
}

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    private http = inject(HttpClient);

    getMe(): Observable<CurrentUserProfile> {
        return this.http.get<BaseOutput<CurrentUserProfile>>('/backoffice/v1/users/me')
            .pipe(map(res => res.data));
    }
}
